<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-help-circle" inline class="ml-0 px-5 py-4">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">Tour</div>
      </template>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-0"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 100%"
      />
      <v-divider class="mt-5" />
      <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        :loading="loading"
        :mobile-breakpoint="800"
        no-data-text="Nenhuma registro disponível"
        no-results-text="Nenhum registro correspondente encontrado"
      />
    </base-material-card>
  </v-container>
</template>

<script>
  export default {
    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      search: '',
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Nome',
          value: 'nome'
        }
      ]
    })
  };
</script>